import { useIntl } from "react-intl"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { useQuery } from "../commons/utils"
import { setInstance } from "./IntlInstance"
import {
  updateLocale,
  FALLBACK_LOCALE_CODE,
  getCachedLocaleCode,
  getFirstSupportedBrowserLocaleCode
} from "./localeUtils"

/**
 * Component in charge to update Intl locale if URL argument "lang" is used.
 *
 * @returns {null}
 * @constructor
 */
export default function InitIntlInstance() {
  const intl = useIntl()
  const dispatch = useDispatch()
  const httpArg = useQuery()

  // init Intl instance singleton
  useEffect(() => {
    setInstance(intl)
  }, [intl])

  useEffect(() => {
    // The fallbacks are arranged in an order of precedence.
    // Top (highest priority) --> Bottom (fallback)
    const targetLocale =
      httpArg.get("lang") ?? // Query parameter to specify the display language used in templates
      getCachedLocaleCode() ?? // Previously selected or overridden locale stored in the browser's cache
      getFirstSupportedBrowserLocaleCode() ?? // A user-preferred locale stored in the browser
      FALLBACK_LOCALE_CODE // A default, supported locale when nothing else is available

    dispatch(updateLocale(targetLocale))
  }, [dispatch, httpArg])
  return null
}
